import { Browser } from "@capacitor/browser";
import { Capacitor } from "@capacitor/core";

// Ícono oficial de WhatsApp (mismo que el botón del login).
const WhatsAppSvg = ({ size = 22 }) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    width={size}
    height={size}
    style={{ color: "#fff" }}
    aria-hidden
  >
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
  </svg>
);

/**
 * Modal "Hablanos" para órdenes externas RCTA.
 * La orden está fuera del circuito interno de turnos: el paciente no toma turno
 * desde el portal, sino que contacta a un agente por WhatsApp.
 *
 * NOTA: los números son placeholders — reemplazar por los definitivos de Cemedic.
 */
// numero: formato internacional para wa.me (AR mobile = 54 9 + área + número, sin símbolos).
// numeroVisible: como lo ve el paciente.
const WHATSAPP_CONTACTOS = [
  {
    etiqueta: "Consultas - Turnos",
    numeroVisible: "11 6950-9892",
    numero: "5491169509892",
  },
  {
    etiqueta: "Quirófano",
    numeroVisible: "11 7201-7776",
    numero: "5491172017776",
  },
];
const MENSAJE_WSP =
  "Hola, tengo una orden médica y necesito hacer una consulta.";

const ContactoRctaModal = ({ onClose }) => {
  const abrirWhatsApp = (numero) => {
    const url = `https://wa.me/${numero}?text=${encodeURIComponent(MENSAJE_WSP)}`;
    if (Capacitor.isNativePlatform()) {
      Browser.open({ url });
    } else {
      window.open(url, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div style={styles.header}>
          <span className="rb18b c-latex30">Contáctanos</span>
          <span style={styles.close} className="pointer" onClick={onClose}>
            ✕
          </span>
        </div>
        <p className="rb14l c-latex30" style={styles.texto}>
          Esta orden está fuera de nuestro circuito de turnos online. Si
          necesitás coordinar un turno, escribinos por WhatsApp y un agente te
          ayuda.
        </p>
        <div style={styles.lista}>
          {WHATSAPP_CONTACTOS.map((c, i) => (
            <button
              key={i}
              type="button"
              className="pointer"
              style={styles.btnWsp}
              onClick={() => abrirWhatsApp(c.numero)}
            >
              <WhatsAppSvg size={22} />
              <span style={styles.btnText}>
                <span className="rb14b c-white">{c.etiqueta}</span>
                <span className="rb12l c-white">WhatsApp · {c.numeroVisible}</span>
              </span>
            </button>
          ))}
        </div>
        <button
          type="button"
          className="rb16b c-latex30 pointer"
          style={styles.btnCerrar}
          onClick={onClose}
        >
          Cerrar
        </button>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.45)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
  },
  modal: {
    width: "min(420px, 92vw)",
    background: "var(--color-white, #fff)",
    borderRadius: 12,
    padding: "20px",
    display: "flex",
    flexDirection: "column",
    gap: 14,
    boxShadow: "0 8px 32px rgba(0,0,0,0.25)",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  close: { fontSize: 18, color: "var(--color-latex30)" },
  texto: { margin: 0, lineHeight: 1.4 },
  lista: { display: "flex", flexDirection: "column", gap: 10 },
  btnWsp: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    background: "#1da851",
    border: "none",
    borderRadius: 10,
    padding: "12px 16px",
    width: "100%",
    textAlign: "left",
  },
  wspIcon: { fontSize: 20 },
  btnText: { display: "flex", flexDirection: "column" },
  btnCerrar: {
    background: "transparent",
    border: "1px solid var(--color-latex30)",
    borderRadius: 8,
    padding: "8px 18px",
    alignSelf: "flex-end",
  },
};

export default ContactoRctaModal;
